import { priceBookIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import {
  CurrencySchema,
  PriceBookEntrySchema,
} from "@redotech/redo-model/price-book/price-book";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const createPriceBookEntry = unaryRpc({
  name: "createPriceBookEntry" as const,
  input: z.object({
    priceBookId: priceBookIdFormat.schema,
    productId: productIdFormat.schema,
    fixedPrice: z.bigint().nullable().optional(),
    currency: CurrencySchema.nullable().optional(),
    kind: z.string().optional(),
  }),
  output: z.object({ entry: PriceBookEntrySchema }),
});
